import type { ProjectElementTagResponse } from '@/types/project-element-tag';

function isBlankUrl(value: string | null | undefined): boolean {
  return value == null || value.trim() === '';
}

export function mergeUpdatedElementTag(
  current: ProjectElementTagResponse,
  result: ProjectElementTagResponse
): ProjectElementTagResponse {
  const sameSelectedResource =
    (result.selectedResourceId ?? null) === (current.selectedResourceId ?? null);

  return {
    ...result,
    resourceUrl:
      isBlankUrl(result.resourceUrl) && sameSelectedResource
        ? current.resourceUrl
        : result.resourceUrl,
    tagImageUrl: isBlankUrl(result.tagImageUrl) ? current.tagImageUrl : result.tagImageUrl,
    resourceCount:
      result.resourceCount === 0 && current.resourceCount > 0
        ? current.resourceCount
        : result.resourceCount,
    selectedResourceId: result.selectedResourceId ?? current.selectedResourceId,
    humanAssetType: sameSelectedResource
      ? (result.humanAssetType ?? current.humanAssetType)
      : result.humanAssetType,
    humanAssetStatus: sameSelectedResource
      ? (result.humanAssetStatus ?? current.humanAssetStatus)
      : result.humanAssetStatus,
  };
}
